module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-bar-flag-5168b998301858f49e474c8782c4a5b8.svg";